import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { UserPrefsInfo } from '../../types/generated/UserPrefsInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetUserPrefsQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type GetUserPrefsQuery = { __typename?: 'Query', getUserPrefs: { __typename?: 'UserPrefs', id: string, privateCommentsEnabled?: boolean | null, timeDisplayFormat: Types.TimeDisplayFormat, previewEnvironmentBanner?: boolean | null, transcriptionsLanguage?: string | null, hasTranscriptionConsent?: boolean | null, downloadSettings: { __typename?: 'UserPrefsDownloadSettings', locations?: Array<string> | null, shouldImport?: boolean | null }, exploreTemplatesBannerSettings: { __typename?: 'UserPrefsExploreTemplatesBannerSettings', shouldShowExploreTemplatesBanner: boolean } } };


export const GetUserPrefs = /*#__PURE__*/ gql`
    query GetUserPrefs($userId: ID!) {
  getUserPrefs(userId: $userId) @client {
    ...UserPrefsInfo
  }
}
    ${UserPrefsInfo}` as unknown as DocumentNode<GetUserPrefsQuery, GetUserPrefsQueryVariables>;

          

          export const useGetUserPrefsQuery = (options?:QueryHookOptions<GetUserPrefsQuery, GetUserPrefsQueryVariables>) => useQuery(GetUserPrefs, options);

          

          export type GetUserPrefsQueryOptions = QueryHookOptions<GetUserPrefsQuery, GetUserPrefsQueryVariables>;

          

          export const useGetUserPrefsLazyQuery = (options?:LazyQueryHookOptions<GetUserPrefsQuery, GetUserPrefsQueryVariables>) => useLazyQuery(GetUserPrefs, options);

          

          export type GetUserPrefsQueryResult = ReturnType<typeof useGetUserPrefsQuery>;

          
